import React from 'react'
import { cn } from 'shared/utils'
import { useReactiveVar } from '@apollo/client'

import { ConditionRender, ScrollToTopButton } from 'components'
import { ProjectFeed } from 'modules/Feed/containers'
import { Products, ProjectInfo, ProjectDetailLeftSide } from 'modules/Projects/containers'
import { FeedbackModal } from 'modulesCommon/FeedbackModal/containers'
import { activeProjectTabVar } from 'modules/Projects/store'
import { TourDates } from 'modules/TourDates/containers'
import Footer from 'components/Footer/Footer'

const ProjectDetailsPage = () => {
  const activeProjectTab = useReactiveVar(activeProjectTabVar)
  const colCountNum = activeProjectTab === 'products' ? 24 : 12

  return (
    <div className="page">
      <div className="sbx-row sbx-row-gutter-50">
        <div className="sbx-col-xs-24 sbx-col-xs-order-1 sbx-col-md-24 sbx-col-md-order-1 sbx-col-lg-24 sbx-col-lg-order-0">
          <div className={cn('sbx-row sbx-row-gutter-20 page__subcontent', {
            'page__subcontent-offset': activeProjectTab === 'stories'
          })}>
            <div className={`sbx-col-xs-24 sbx-col-xs-order-1 sbx-col-md-24 sbx-col-md-order-1 sbx-col-lg-${colCountNum} sbx-col-lg-order-0`}>
              <ConditionRender condition={activeProjectTab === 'stories'} component={<ProjectFeed />} />
              <ConditionRender condition={activeProjectTab === 'projectInfo'} component={<ProjectInfo />} />
              <ConditionRender condition={activeProjectTab === 'products'} component={<Products isExtended />} />
              <ConditionRender condition={activeProjectTab === 'tour'} component={<TourDates />} />
            </div>
            <div className="page__subcontent-sidebar sbx-col-xs-24 sbx-col-xs-order-0 sbx-col-md-24 sbx-col-md-order-0 sbx-col-lg-12 sbx-col-lg-order-1">
              <ProjectDetailLeftSide />
            </div>
          </div>
          <ConditionRender condition={activeProjectTab === 'products'} component={<Footer />} />
        </div>
      </div>
      <FeedbackModal />
      <ScrollToTopButton />
    </div>
  )
}

export default ProjectDetailsPage
